import { Shield } from 'lucide-react';

/**
 * Amber "Staff" pill. Marks UI surfaces gated to admin users.
 * Use anywhere a staff-only section or feature header needs labelling.
 *
 * `compact` keeps only the shield, for surfaces where the pill would compete with
 * the title (a client-facing card previewed by staff). The label stays available
 * to screen readers and on hover.
 */
export function StaffBadge({ compact = false }: { compact?: boolean }) {
    if (compact) {
        return (
            <span
                role="img"
                aria-label="Staff only"
                title="Staff only"
                className="inline-flex align-middle text-[var(--warning)]"
            >
                <Shield className="h-3.5 w-3.5" aria-hidden="true" />
            </span>
        );
    }
    return (
        <span className="inline-flex items-center gap-1 rounded-full bg-[var(--warning-subtle)] px-2 py-0.5 align-middle text-[10px] font-medium text-[var(--warning)]">
            <Shield className="h-2.5 w-2.5" />
            Staff
        </span>
    );
}
